import { GET_CATEGORIES } from '../constants/ActionTypes';

/**
 * Get contact screen propreties.
 * @function getCategories
 * @returns {Object} Get the contact screeen propreties
 */
export function getCategories() {
  return {
    type: GET_CATEGORIES,
    request: {
      op: 'get',
      path: '/@category',
    },
  };
}
